import styled from "styled-components";
import { ReactComponent as LocationIcon }  from '../../assets/images/location-icon.svg';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0px;
  position: fixed;
  right: 0;
  left: 0;
  bottom: 0px;
  z-index: 99;
  transition: opacity 150ms, transform 150ms;
  pointer-events: none;
  opacity: 0;
  transform: translateY(-16px);
  &.active {
    opacity: 1;
    transform: translateY(0px);
  }
  @media (min-width: 601px) {
    bottom: 50px;
    margin: 8px;
  }
`;

export const SnackCont = styled.div`
  box-sizing: border-box;
  padding: 20px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  width: 100%;
  max-width: 693px;
  background-color: #F1F2F3;
  box-shadow: 1px 10px 6px rgba(0,0,0,.29);
  pointer-events: auto;
  text-align: center;
  position: relative;
  @media (min-width: 601px) {
    flex-direction: row;
    padding: 30px;
    border-radius: 11px;  
    border: 1px solid #0077DA;
    text-align: left;
  }
`;

export const Text = styled.div`
  font-family: "NotoSansRegular";
  font-size: 14px;
  line-height: 19px;
  color: #1D1E1F;
  margin: 15px 0;
  max-width: 265px;
  @media (min-width: 601px) {
    font-size: 18px;
    line-height: 24px;
    margin: 0 35px;
    max-width: 100%;
  }
`;

export const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
  outline: none;
  background-color: transparent;
  border: none;
  box-shadow: 0 3px 6px rgba(0,0,0,.16);
  background-color: #FFF;
  padding: 0px;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  &:hover{
    background-color: rgb(0, 119, 218);
    & line {
      stroke: #FFF;
    }
  }
`;

export const LocIcon = styled(LocationIcon)`
  width: 58px;
  flex-shrink: 0;
`;